let whichToKeyMap = {
      3: 'Cancel',
      6: 'Help',
      8: 'Backspace',
      9: 'Tab',
      12: 'Clear',
      13: 'Enter',
      16: 'Shift',
      17: 'Control',
      18: 'Alt',
      19: 'Pause',
      20: 'CapsLock',
      27: 'Escape',
      28: 'Convert',
      29: 'NonConvert',
      30: 'Accept',
      31: 'ModeChange',
      32: ' ',
      33: 'PageUp',
      34: 'PageDown',
      35: 'End',
      36: 'Home',
      37: 'ArrowLeft',
      38: 'ArrowUp',
      39: 'ArrowRight',
      40: 'ArrowDown',
      41: 'Select',
      42: 'Print',
      43: 'Execute',
      44: 'PrintScreen',
      45: 'Insert',
      46: 'Delete',
      48: ['0', ')'],
      49: ['1', '!'],
      50: ['2', '@'],
      51: ['3', '#'],
      52: ['4', '$'],
      53: ['5', '%'],
      54: ['6', '^'],
      55: ['7', '&'],
      56: ['8', '*'],
      57: ['9', '('],
      91: 'OS',
      93: 'ContextMenu',
      144: 'NumLock',
      145: 'ScrollLock',
      181: 'VolumeMute',
      182: 'VolumeDown',
      183: 'VolumeUp',
      186: [';', ':'],
      187: ['=', '+'],
      188: [',', '<'],
      189: ['-', '_'],
      190: ['.', '>'],
      191: ['/', '?'],
      192: ['`', '~'],
      219: ['[', '{'],
      220: ['\\', '|'],
      221: [']', '}'],
      222: ["'", '"'],
      224: 'Meta',
      225: 'AltGraph',
      246: 'Attn',
      247: 'CrSel',
      248: 'ExSel',
      249: 'EraseEof',
      250: 'Play',
      251: 'ZoomOut'
};

// Function keys (F1-24).
for (let i = 1; i < 25; i++) {
    whichToKeyMap[111 + i] = 'F' + i;
}

// Printable ASCII characters.
let letter = '';
for (let i = 65; i < 91; i++) {
    letter = String.fromCharCode(i);
    whichToKeyMap[i] = [letter.toLowerCase(), letter.toUpperCase()];
}

/**
 * Wylicza wartość dla właściwości `key` na podstawie przekazanego eventu
 * Właściwość `which` na której się opieramy uwzględnia modyfikatory (shift, alt) wyłącznie dla eventu `keypress`
 * Dla pozostałych eventów musimy sami zaaplikować modyfikatory aby uzyskać odpowiedni znak.
 *
 * Ponieważ flaga altKey nie jest odpowiednio ustawiona przez Selenium
 * polskie litery są właściwie obsługiwane wyłącznie w `keypress`
 */
function keyForEvent(event: KeyboardEvent) {
    let key = whichToKeyMap[event.which];
    if (Array.isArray(key)) {
        key = key[+event.shiftKey];
    }
    return key || String.fromCharCode(event.which) || 'Unidentified';
}

let descriptor = Object.getOwnPropertyDescriptor(KeyboardEvent.prototype, 'key');

Object.defineProperty(KeyboardEvent.prototype, 'key', {
    /**
     * Override fix for nonstandard `key` values
     * Selenium ma bug przez który wartości key nie są poprawnie zdefiniowane.
     * Nadpisujemy domyślną implementacje getera dla key.
     */
    get: function () {
        let key = descriptor.get.call(this);
        if (key === '' || key === 'Unidentified') {
            key = keyForEvent(this);
        }
        return key;
    }
});